import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/AsnService'

export const getData = createAsyncThunk('asn/data/getData', async data => {
    const response = await getApiData(data)
    return response.data
})

export const getRecord = createAsyncThunk('asn/data/getRecord', async id => {
    const response = await getApiRecord(id)
    return response.data
})

const today = new Date()
const pastDate = new Date()
pastDate.setDate(today.getDate() - 14)

const recordData = {
    site: '',
    client: '',
    asn: '',
    asn_type: '',
    reference_1: '',
    reference_2: '',
    supplier: '',
    status: '',
    created_date: '',
    closed_date: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 100,
    query: '',
    selectedTab: '',
    startDate: pastDate?.toISOString()?.split('T')[0],
    endDate: '',
    status: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'asn/data',
    initialState: {
        loading: false,
        record: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setRecord: (state, { payload }) => {
            state.record = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.data
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, state => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, state => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setRecord, setTableData } = dataSlice.actions

export default dataSlice.reducer
